// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBarChartOutlinedSvg from "@fishx/icons-svg/es/asn/PBarChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PBarChartOutlined = function PBarChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBarChartOutlinedSvg
  }));
};

PBarChartOutlined.displayName = 'PBarChartOutlined';
export default React.forwardRef(PBarChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBarChartOutlined.js
// module id = 3236
// module chunks = 0